import React from 'react'

import {
    Modal,
    Paper,
    IconButton,
    Typography,
    Container,
    Slide,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'

import { ProjectDetail } from '../../../Organization/pages/OrganizationProjectPage/ProjectDetail'
import { PortfolioSchedule } from '../../../../models'
import { Service } from '../../../../models'
import { Routes } from '../../../../navigation/config/routes'
import { resolveRoute } from '../../../../helpers'

interface Props {
    open: boolean
    onClose: () => void
    scheduleDetail: PortfolioSchedule | null
    workorderList: any[]
    workorderLoading: boolean
    serviceList: Service[]
    projectName: string
}

export const ProjectDetailModal: React.FC<Props> = ({
    open,
    onClose,
    scheduleDetail,
    workorderList,
    workorderLoading,
    serviceList,
    projectName,
}) => {
    const navigateToScheduleDetail = (scheduleDetail: PortfolioSchedule) => {
        let route = Routes.apartment.schedule.detail as string
        if (!scheduleDetail.active) {
            route = Routes.apartment.schedule.archived as string
        }
        const params = new URLSearchParams({
            apartment: scheduleDetail.apartment.id.toString(),
            setup: 'false',
        }).toString()

        const url = `${resolveRoute(route, ':id', scheduleDetail.id)}?${params}`

        window.open(url, '_blank')
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            closeAfterTransition
        >
            <Slide direction="up" in={open}>
                <Paper
                    style={{
                        width: 'calc(100vw - 250px)',
                        backgroundColor: 'white',
                        height: 'calc(100vh - 150px)',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Container
                        maxWidth={false}
                        disableGutters
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px 16px',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                            width: '100%',
                        }}
                    >
                        <Typography variant="h6">
                            {projectName} Details
                        </Typography>
                        <IconButton onClick={onClose} size="small">
                            <Close />
                        </IconButton>
                    </Container>
                    <Container
                        maxWidth={false}
                        disableGutters
                        style={{
                            flex: 1,
                            overflow: 'auto',
                            width: '100%',
                        }}
                    >
                        <ProjectDetail
                            scheduleDetail={scheduleDetail}
                            scheduleLoading={false}
                            workorderList={workorderList}
                            workorderLoading={workorderLoading}
                            serviceList={serviceList}
                            navigateToScheduleDetail={navigateToScheduleDetail}
                        />
                    </Container>
                </Paper>
            </Slide>
        </Modal>
    )
}
